import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { BaseModalComponent } from "../base-modal/base-modal.component";
import { StarLineItemComponent } from "../star-line-item/star-line-item.component";

@Component({
  selector: "app-dialog-super-stars",
  templateUrl: "./dialog-super-stars.component.html",
  styleUrls: ["./dialog-super-stars.component.scss"],
  standalone: true,
  imports: [CommonModule, BaseModalComponent, StarLineItemComponent],
})
export class DialogSuperStarsComponent {
  stars: string[];

  constructor(
    public dialogRef: MatDialogRef<DialogSuperStarsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {
    this.stars = data;
  }

  closeWithStar(star: string): void {
    this.dialogRef.close(star);
  }

  close() {
    this.dialogRef.close();
  }
}
